import { Box } from '@givebutter/primitives/box';
import { Tag } from '@givebutter/primitives/tag';
import { faEnvelope, faPalette } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import EmailPreview from 'assets/js/pages/engage/components/MessageBuilder/EmailPreview';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useCurrentEngageMessage } from 'customHooks/useCurrentEngageMessage';

const EngageMetricsEmailPreview = () => {
    const { data: message } = useCurrentEngageMessage();
    const { apiUrl } = useAppState();
    const { accountId } = useCurrentAccount();

    return (
        <Box className="inset-0 h-96 overflow-hidden bg-gray-100 md:absolute md:h-auto">
            <div className="relative h-full w-full p-16 pb-0">
                <div className="h-full w-full overflow-hidden rounded-t-lg">
                    <EmailPreview messageId={message.id} autoSaving={false} />
                </div>
                <div className="absolute left-6 top-4">
                    <Tag className="space-x-2 rounded-full">
                        <FontAwesomeIcon
                            icon={message.editor === 'basic' ? faEnvelope : faPalette}
                        />
                        {message.editor === 'basic' ? 'Classic' : 'Visual'}
                    </Tag>
                </div>
                <a
                    href={`${apiUrl}/dashboard/accounts/${accountId}/messages/${message.id}/preview`}
                    className="absolute bottom-6 left-6 right-6 rounded-lg border border-gray-200 bg-white p-2 text-center font-thin text-black"
                    target="_blank"
                    rel="noreferrer"
                >
                    View full email
                </a>
            </div>
        </Box>
    );
};

export { EngageMetricsEmailPreview };
